import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { convertThenFormat, formatDateTime } from "../../common-data/Converts";
import { BinIcon1, EditIcon1 } from "../../../images/icons/icons";

const FDIncentivesLogs = ({
  userInfoData,
  callFunction,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const dispatch = useDispatch();
  const { fdIncentivesLoading, fdIncentivesError, fdIncentives } = useSelector(
    (state) => state.incentives
  );

  const iniTbDatas = {
    pagination: [],
    allData: [],
  };
  const [allTbDatas, setAllTbDatas] = useState(iniTbDatas);

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/incentive/fd/slab/delete",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !fdIncentivesLoading &&
      !fdIncentivesError &&
      fdIncentives?.status &&
      fdIncentives?.data?.length > 0
    ) {
      setAllTbDatas((prevs) => ({
        ...prevs,
        allData: fdIncentives.data,
        pagination:
          fdIncentives?.pagination?.length > 0 ? fdIncentives.pagination : [],
      }));
    } else {
      setAllTbDatas(iniTbDatas);
    }
  }, [fdIncentivesLoading, fdIncentivesError, fdIncentives]);

  const tbColumns = [
    {
      dataField: "category",
      text: "gym category",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
    {
      dataField: "revenue",
      text: "target",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.revenue || 0)}
          </span>
        );
      },
    },
    {
      dataField: "incentive",
      text: "incentive",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.incentive || 0)}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.status === "active"
                ? "tb-badge-success"
                : row?.lead_status === "inactive"
                ? "not-assigned"
                : "tb-badge-success-2"
            }`}
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="edit"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "edit",
                }))
              }
            >
              <EditIcon1 />
              edit
            </button>

            <button
              key="delete"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() => {
                const payload = {
                  uid: row?.uid,
                };

                handleDelete(payload);
              }}
            >
              <BinIcon1 />
              delete
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="common-table-container tb-bordered mt15">
      <CommonTable
        tableData={allTbDatas.allData}
        tablePagination={allTbDatas.pagination}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={fdIncentivesLoading}
      />
    </div>
  );
};

export default FDIncentivesLogs;
